
import * as firebase from 'firebase';
import firestore from 'firebase/firestore'




const config = {
    apiKey: "AIzaSyDPpEqBJJ4_fIuP-nK1x9-ULWcVjgSwG8k",
    authDomain: "mbn-form.firebaseapp.com",
    databaseURL: "https://mbn-form.firebaseio.com",
    projectId: "mbn-form",
    storageBucket: "mbn-form.appspot.com",
    messagingSenderId: "865832125195",
    appId: "1:865832125195:web:e34c495963376bb7f7180e"
};
firebase.initializeApp(config);



export default firebase;